import { render, staticRenderFns } from "./Enterprises.vue?vue&type=template&id=54f31baa&scoped=true&"
import script from "./Enterprises.vue?vue&type=script&lang=js&"
export * from "./Enterprises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f31baa",
  null
  
)

export default component.exports